import type { Guide } from '../types';

/**
 * S-25.10-06 — reguła podwykonawcy klienta: właściciel, data obowiązywania, historia (scenariusz e2e 33). Rekord:
 * kontrahent zlecenia DEMO/2026/10/RK1 — reguła „dozwolony” z właścicielem i zmianą zaplanowaną na „zakaz”.
 */
export const guide: Guide = {
  flagKey: 'subcontractorRuleOwnership',
  title: 'Reguła podwykonawcy klienta: właściciel, data obowiązywania, historia',
  whatItDoes:
    'Reguła podwykonawcy na karcie kontrahenta (dozwolony, warunkowy, zakaz) ma właściciela — osobę odpowiedzialną za regułę — i datę, od której obowiązuje. Zmianę można zaplanować: do wskazanej daty publikacja na giełdzie i zapytania do przewoźników korzystają z obecnej reguły, a zaplanowaną zmianę można odwołać z powodem. Każda zmiana wymaga powodu; historia mówi, co było, co jest, od kiedy, kto i dlaczego. Regułę zmieniają CS i administrator.',
  audience: ['CS', 'administrator', 'trader (podgląd)'],
  presentationItems: ['S-25.10-06'],
  steps: [
    {
      route: '/contractors/:contractorId/show',
      record: { description: 'dowolny kontrahent z kartoteki', listPath: '/contractors' },
      target: 'rule-ownership-note',
      title: 'Reguła z właścicielem i datą obowiązywania',
      description:
        'Przy regule widać, od kiedy obowiązuje i kto jest jej właścicielem (pusty — „właściciel nieustalony”).',
      action: 'Otwórz kartę kontrahenta i przeczytaj sekcję „Podwykonawca — reguła publikacji na giełdach”.',
      recorder: { account: 'cs', demo: { kind: 'contractorOfOrder', number: 'DEMO/2026/10/RK1' } },
    },
    {
      route: '/contractors/:contractorId/show',
      record: { description: 'kontrahent ze zmianą reguły zaplanowaną na przyszłość', listPath: '/contractors' },
      target: 'rule-scheduled',
      title: 'Zmiana zaplanowana',
      description:
        'Nowa reguła z datą „obowiązuje od” w przyszłości czeka na swój termin — do tego czasu obowiązuje obecna. Przycisk „Odwołaj” cofa zaplanowaną zmianę z powodem.',
      action: 'Wybierz regułę, wpisz datę w polu „Obowiązuje od”, powód i kliknij „Zapisz regułę”.',
      recorder: { account: 'cs', demo: { kind: 'contractorOfOrder', number: 'DEMO/2026/10/RK1' } },
    },
    {
      route: '/contractors/:contractorId/show',
      record: { description: 'dowolny kontrahent z kartoteki', listPath: '/contractors' },
      target: 'rule-owner-select',
      title: 'Właściciel reguły',
      description:
        'Właścicielem może być osoba z CS albo administrator. Zmiana właściciela działa od razu i trafia do historii z powodem.',
      action: 'Wybierz właściciela z listy, wpisz powód i kliknij „Zapisz regułę”.',
      recorder: { account: 'cs', demo: { kind: 'contractorOfOrder', number: 'DEMO/2026/10/RK1' } },
    },
    {
      route: '/contractors/:contractorId/show',
      record: { description: 'dowolny kontrahent z kartoteki', listPath: '/contractors' },
      target: 'rule-ownership-history',
      title: 'Historia reguły',
      description:
        'Historia: kiedy, kto, zmiana reguły albo właściciela, od kiedy obowiązuje, stan (obowiązuje, zaplanowana, odwołana) i powód.',
      action: 'Przewiń kartę kontrahenta do „Historia reguły podwykonawcy”.',
      recorder: { account: 'cs', demo: { kind: 'contractorOfOrder', number: 'DEMO/2026/10/RK1' } },
    },
  ],
};
